import './sanmarino/style';
import FormStructure from './sanmarino/form_structure';

export default FormStructure;